import { LicenseType, NotificationChannel, permissionAllowed, SystemDetails, SystemNotifications } from "@ews/react-data";
import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonItem, IonLabel } from "@ionic/react";

import
{
    useModifySystemDetails,
    useModifySystemNotifications,
    useSystem,
    useSystemNotifications,
    useSystemPlansWithoutImages
} from "../../../ReactData/system";

import { useHasLicense } from "../../../HasLicense";
import { useMyPermissions } from "../../../Login/LoginProvider";
import { useIsMobile } from "../../../Responsive";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsTableRow from "../../../Settings/SettingsComponents/SettingsTable/SettingsRow/SettingsTableRow";
import SettingsTableColumn from "../../../Settings/SettingsComponents/SettingsTable/SettingsTableColumn/SettingsTableColumn";
import SettingsTableGrid from "../../../Settings/SettingsComponents/SettingsTable/SettingsTableGrid/SettingsTableGrid";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import notificationStyle from "./NotificationsSettings.module.scss";
import { NotificationsSettingsProps } from "./types";
import { useInvokeInfoPush } from "../../../ReactData/rpc";
import SettingsLabel from "../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel";

import { env } from '../../../Environment';

const NotificationsSettings: React.FC<NotificationsSettingsProps> = ({ systemId }) =>
{

    function setValues(status: boolean)
    {
        const val = status ? NotificationChannel.PUSH | NotificationChannel.EMAIL : NotificationChannel.NONE;

        return {
            fireAlarm: val,
            fireAlert: val,
            preAlarm: val,
            testScenario: val,
            testCondition: val,
            testActivation: val,
            testAlarm: val,
            activeOutput: val,
            fault: val,
            technicalMessage: val,
            disablement: val,
            extinguishingEvent: val,
            status: val,
        };
    }

    const { translate: t } = useL10n();
    const mobileView = useIsMobile();

    const modifySystemNotifications = useModifySystemNotifications();
    const modifySystemDetails = useModifySystemDetails();
    const system = useSystem(systemId);
    const notification = useSystemNotifications(systemId);
    const myPermissions = useMyPermissions();
    const sendInfoPush = useInvokeInfoPush();

    const hasPlanViewLicense = useHasLicense(LicenseType.PLAN_VIEW);

    // const plans = useSystemPlans(system.id || "")?.results;
    const plans = useSystemPlansWithoutImages(systemId || "");


    const allowedToEdit = permissionAllowed(myPermissions.grantSystemAccess || 0);

    function saveSystemDetails(key: keyof SystemDetails, value: any)
    {
        if (!system.id) return;
        modifySystemDetails(system.id!, { [key]: value } as SystemDetails);
    }

    function saveSystemNotifications(key: keyof SystemNotifications, value: any)
    {
        if (!system.id) return;
        modifySystemNotifications(system.id!, { [key]: value } as SystemNotifications);
    }

    function checkedDevice(key: keyof SystemNotifications, device: keyof typeof NotificationChannel, checked: boolean)
    {

        if (!(key in notification)) return;

        const { EMAIL, PUSH } = NotificationChannel;

        if (NotificationChannel[device] === EMAIL) {
            (notification[key] as NotificationChannel) = checked ? ((notification[key] as NotificationChannel) | EMAIL) : ((notification[key] as NotificationChannel) & PUSH);
        }
        if (NotificationChannel[device] === PUSH) {
            (notification[key] as NotificationChannel) = checked ? ((notification[key] as NotificationChannel) | PUSH) : ((notification[key] as NotificationChannel) & EMAIL);
        }
        saveSystemNotifications(key, notification[key]);
    }

    return <>
        <SettingsCol >


            <SettingsTableGrid>
                <SettingsTableRow hidden={mobileView}>
                    <SettingsTableColumn size="4" center={false}>
                        <p style={{ margin: 0 }}>{`${t('[SID_MNU_HK_ONE_EVENT]')}:`}</p>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <p style={{ textAlign: "center", margin: 0 }}>{`${t('COM_FACPMANAGEMENT_SHARE_PUSH')}:`}</p>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <p style={{ textAlign: "center", margin: 0 }}>{`${t('COM_CONTACT_EMAIL_LABEL')}:`}</p>
                    </SettingsTableColumn>
                </SettingsTableRow>


                <SettingsTableRow>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_MNU_TAB_ALARMS]')}`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_FACPMANAGEMENT_SHARE_PUSH"}
                            item={mobileView}
                            //container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.fireAlarm ? (notification.fireAlarm & NotificationChannel.PUSH) === NotificationChannel.PUSH : false}
                            onChange={(checked) => { checkedDevice("fireAlarm", "PUSH", checked); }} />
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_CONTACT_EMAIL_LABEL"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.fireAlarm ? (notification.fireAlarm & NotificationChannel.EMAIL) === NotificationChannel.EMAIL : false}
                            onChange={(checked) => { checkedDevice("fireAlarm", "EMAIL", checked); }} />
                    </SettingsTableColumn>
                </SettingsTableRow>

                <SettingsTableRow>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_DEV_STATE_PREALARM]')}`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_FACPMANAGEMENT_SHARE_PUSH"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.preAlarm ? (notification.preAlarm & NotificationChannel.PUSH) === NotificationChannel.PUSH : false}
                            onChange={(checked) => { checkedDevice("preAlarm", "PUSH", checked); }} />
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_CONTACT_EMAIL_LABEL"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.preAlarm ? (notification.preAlarm & NotificationChannel.EMAIL) === NotificationChannel.EMAIL : false}
                            onChange={(checked) => { checkedDevice("preAlarm", "EMAIL", checked); }} />
                    </SettingsTableColumn>
                </SettingsTableRow>


                <SettingsTableRow>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_EV_FIRE_PREALARM_SH]')}`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_FACPMANAGEMENT_SHARE_PUSH"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.fireAlert ? (notification.fireAlert & NotificationChannel.PUSH) === NotificationChannel.PUSH : false}
                            onChange={(checked) => { checkedDevice("fireAlert", "PUSH", checked); }} />
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_CONTACT_EMAIL_LABEL"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.fireAlert ? (notification.fireAlert & NotificationChannel.EMAIL) === NotificationChannel.EMAIL : false}
                            onChange={(checked) => { checkedDevice("fireAlert", "EMAIL", checked); }} />
                    </SettingsTableColumn>
                </SettingsTableRow>

                <SettingsTableRow>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_ONE_TEST_ALARM]')}`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_FACPMANAGEMENT_SHARE_PUSH"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.testScenario ? (notification.testScenario & NotificationChannel.PUSH) === NotificationChannel.PUSH : false}
                            onChange={(checked) => { checkedDevice("testScenario", "PUSH", checked); }} />
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_CONTACT_EMAIL_LABEL"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.testScenario ? (notification.testScenario & NotificationChannel.EMAIL) === NotificationChannel.EMAIL : false}
                            onChange={(checked) => { checkedDevice("testScenario", "EMAIL", checked); }} />
                    </SettingsTableColumn>
                </SettingsTableRow>

                <SettingsTableRow>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_MNU_TAB_ACT_OUTP]')}`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_FACPMANAGEMENT_SHARE_PUSH"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.activeOutput ? (notification.activeOutput & NotificationChannel.PUSH) === NotificationChannel.PUSH : false}
                            onChange={(checked) => { checkedDevice("activeOutput", "PUSH", checked); }} />
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_CONTACT_EMAIL_LABEL"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.activeOutput ? (notification.activeOutput & NotificationChannel.EMAIL) === NotificationChannel.EMAIL : false}
                            onChange={(checked) => { checkedDevice("activeOutput", "EMAIL", checked); }} />
                    </SettingsTableColumn>
                </SettingsTableRow>

                <SettingsTableRow>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_MNU_TAB_FAULTS]')}`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_FACPMANAGEMENT_SHARE_PUSH"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer} label={mobileView}
                            checked={notification.fault ? (notification.fault & NotificationChannel.PUSH) === NotificationChannel.PUSH : false}
                            onChange={(checked) => { checkedDevice("fault", "PUSH", checked); }} />
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_CONTACT_EMAIL_LABEL"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.fault ? (notification.fault & NotificationChannel.EMAIL) === NotificationChannel.EMAIL : false}
                            onChange={(checked) => { checkedDevice("fault", "EMAIL", checked); }} />
                    </SettingsTableColumn>
                </SettingsTableRow>

                <SettingsTableRow>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_EV_TECHN_MESS_ALARM]')}`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_FACPMANAGEMENT_SHARE_PUSH"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.technicalMessage ? (notification.technicalMessage & NotificationChannel.PUSH) === NotificationChannel.PUSH : false}
                            onChange={(checked) => { checkedDevice("technicalMessage", "PUSH", checked); }} />
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_CONTACT_EMAIL_LABEL"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.technicalMessage ? (notification.technicalMessage & NotificationChannel.EMAIL) === NotificationChannel.EMAIL : false}
                            onChange={(checked) => { checkedDevice("technicalMessage", "EMAIL", checked); }} />
                    </SettingsTableColumn>
                </SettingsTableRow>

                <SettingsTableRow>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_EV_TECHN_MESS_SW_OFF_ZONE_SH]')}`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_FACPMANAGEMENT_SHARE_PUSH"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.disablement ? (notification.disablement & NotificationChannel.PUSH) === NotificationChannel.PUSH : false}
                            onChange={(checked) => { checkedDevice("disablement", "PUSH", checked); }} />
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_CONTACT_EMAIL_LABEL"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.disablement ? (notification.disablement & NotificationChannel.EMAIL) === NotificationChannel.EMAIL : false}
                            onChange={(checked) => { checkedDevice("disablement", "EMAIL", checked); }} />
                    </SettingsTableColumn>
                </SettingsTableRow>

                <SettingsTableRow>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_MNU_TAB_EXT_EV]')}`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_FACPMANAGEMENT_SHARE_PUSH"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.extinguishingEvent ? (notification.extinguishingEvent & NotificationChannel.PUSH) === NotificationChannel.PUSH : false}
                            onChange={(checked) => { checkedDevice("extinguishingEvent", "PUSH", checked); }} />
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_CONTACT_EMAIL_LABEL"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.extinguishingEvent ? (notification.extinguishingEvent & NotificationChannel.EMAIL) === NotificationChannel.EMAIL : false}
                            onChange={(checked) => { checkedDevice("extinguishingEvent", "EMAIL", checked); }} />
                    </SettingsTableColumn>
                </SettingsTableRow>

                <SettingsTableRow>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_MNU_TAB_STATUS]')}`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_FACPMANAGEMENT_SHARE_PUSH"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.status ? (notification.status & NotificationChannel.PUSH) === NotificationChannel.PUSH : false}
                            onChange={(checked) => { checkedDevice("status", "PUSH", checked); }} />
                    </SettingsTableColumn>
                    <SettingsTableColumn >
                        <SettingsCheckbox
                            disabled={!allowedToEdit}
                            text={"COM_CONTACT_EMAIL_LABEL"}
                            item={mobileView}
                            container={mobileView}
                            className={notificationStyle.checkboxContainer}
                            label={mobileView}
                            checked={notification.status ? (notification.status & NotificationChannel.EMAIL) === NotificationChannel.EMAIL : false}
                            onChange={(checked) => { checkedDevice("status", "EMAIL", checked); }} />
                    </SettingsTableColumn>
                </SettingsTableRow>

            </SettingsTableGrid>
            <IonItem lines="none">
                <div style={{ width: "100%" }}>
                    <IonButton
                        disabled={!allowedToEdit}
                        color={"success"}
                        expand={"full"}
                        onClick={() =>
                        {
                            const allValues = setValues(true);
                            modifySystemNotifications(system.id!, allValues as SystemNotifications);

                        }}>{t("TD_GROSS_ALLE")}</IonButton>
                </div>
            </IonItem>
            <IonItem>
                <div style={{ width: "100%" }}>
                    <IonButton
                        disabled={!allowedToEdit}
                        color={"danger"}
                        expand={"full"}
                        onClick={() =>
                        {
                            const defaultValues = setValues(false);
                            modifySystemNotifications(system.id!, defaultValues as SystemNotifications);

                        }}>{t("TPL_BEEZ3_RESET")}</IonButton>
                </div>
            </IonItem>
        </SettingsCol>

        <SettingsCol >
            <SettingsCheckbox
                disabled={!(hasPlanViewLicense && plans.length)}
                text={"[REACT_SEND_PLAN]"}
                checked={system.sendEmailFireAlarmPDF || false}
                onChange={(checked) => { saveSystemDetails("sendEmailFireAlarmPDF", checked); }} >
                <SettingsTextInput
                    disabled={!(hasPlanViewLicense && plans.length)}
                    text={"[REACT_RECEIVER]"}
                    endText=" 1"
                    inputType={"text"}
                    value={system.receiver1}
                    onChange={(value) => saveSystemDetails("receiver1", value)}
                />
                <SettingsTextInput
                    disabled={!(hasPlanViewLicense && plans.length)}
                    text={"[REACT_RECEIVER]"}
                    endText=" 2"
                    inputType={"text"}
                    value={system.receiver2}
                    onChange={(value) => saveSystemDetails("receiver2", value)}
                />
                <SettingsTextInput
                    disabled={!(hasPlanViewLicense && plans.length)}
                    text={"[REACT_RECEIVER]"}
                    endText=" 3"
                    inputType={"text"}
                    value={system.receiver3}
                    onChange={(value) => saveSystemDetails("receiver3", value)}
                />
            </SettingsCheckbox>
        </SettingsCol>
        <SettingsCol >
            <IonItem lines="none">
                <textarea
                    disabled={!allowedToEdit}
                    style={{ width: "100%" }}
                    rows={10}
                    maxLength={env.APP_INFO_MESSAGE_MAX_CHARACTERS}
                    defaultValue={system.infoMessage}
                    onBlur={({ target }) =>
                    {
                        let { value } = target;
                        value = value.trim().substring(0, env.APP_INFO_MESSAGE_MAX_CHARACTERS);
                        target.value = value;

                        if (value !== system.infoMessage) {
                            saveSystemDetails("infoMessage", value);
                        }
                    }}
                />
            </IonItem>
            <SettingsLabel
                text={t('[REACT_INFO_MESSAGE_MAX_CHARACTERS]', { characters: `${env.APP_INFO_MESSAGE_MAX_CHARACTERS}` })}

            />
            {allowedToEdit && <IonItem lines="none">
                <div style={{ width: "100%" }}>
                    <IonButton
                        color={"success"}
                        disabled={!system.infoMessage}
                        expand={"full"}
                        onClick={async () =>
                        {
                            await sendInfoPush({
                                "systemId": systemId,
                                "pushMessage": {
                                    title: `${system.name} [${system.systemNumber!}]`,
                                    message: `${system.infoMessage}`
                                }
                            });

                        }}>{t("[REACT_SEND_INFO_PUSH]")}</IonButton>
                </div>
            </IonItem>}
        </SettingsCol>
    </>;
};

export default NotificationsSettings;
